import React, { useState, useEffect, useRef } from "react";
 
const LocationMapComponent = ({
  isSolarFullScreen,
  isFullscreen,
  mapData,
  type,
  setNearByStateSelected,
  setNearByCitySelected,
  locationStatusChoice,
}) => {
  const [center, setCenter] = useState({ lat: 21.7679, lng: 78.8718 });
  const [zoom, setZoom] = useState(5);
  const mapInstanceRef = useRef(null);
  const markerClusterRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
 
  // const mapData = [
  //   {
  //     state: "Gujarat",
  //     latitude: 22.2587,
  //     longitude: 71.1924,
  //     count: 1000,
  //     cities: [
  //       {
  //         city: "Ahmedabad",
  //         latitude: 23.0225,
  //         longitude: 72.5714,
  //         count: 500,
  //       },
  //       { city: "Surat", latitude: 21.1702, longitude: 72.8311, count: 300 },
  //       { city: "Kutch", latitude: 23.7337, longitude: 69.8597, count: 600 },
  //     ],
  //   },
  //   {
  //     state: "Maharashtra",
  //     latitude: 19.7515,
  //     longitude: 75.7139,
  //     count: 1500,
  //     cities: [
  //       { city: "Mumbai", latitude: 19.076, longitude: 72.8777, count: 800 },
  //       { city: "Pune", latitude: 18.5204, longitude: 73.8567, count: 700 },
  //     ],
  //   },
  //   {
  //     state: "Delhi",
  //     latitude: 28.7041,
  //     longitude: 77.1025,
  //     count: 200,
  //     cities: [
  //       {
  //         city: "New Delhi",
  //         latitude: 28.6139,
  //         longitude: 77.209,
  //         count: 2000,
  //       },
  //     ],
  //   },
  // ];
 
  const mapContainerStyle = {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    borderRadius: "8px",
  };
 
  useEffect(() => {
    const loadMapplsScript = () => {
      if (window.mappls && window.mappls.Map) {
        setIsLoaded(true);
        return;
      }
 
      const script = document.createElement("script");
      script.src =
        "https://apis.mappls.com/advancedmaps/api/b549c76376745c9166019ff7da79a72d/map_sdk?layer=vector&v=3.0&plugins=pinToLatLng";
      script.async = true;
      script.onload = () => setIsLoaded(true);
      script.onerror = () => console.error("Failed to load Mappls SDK");
      document.body.appendChild(script);
    };
 
    loadMapplsScript();
  }, []);
 
  useEffect(() => {
    if (!isLoaded) return;
 
    if (!mapInstanceRef.current) {
      const map = new window.mappls.Map("map", {
        center: [center.lat, center.lng],
        zoom,
        zoomControl: type !== "Product",
      });
 
      mapInstanceRef.current = map;
 
      map.on("load", () => {
        addCircleMarkers(map);
      });
 
      map.on("zoomend", () => {
        const newZoom = map.getZoom();
        setZoom(newZoom);
      });
 
      map.on("click", (e) => {
        const features = map.queryRenderedFeatures(e.point, {
          layers: ["mappls-marker-layer"],
        });
 
        if (features.length) {
          const clickedFeature = features[0];
          if (clickedFeature.properties.cluster) {
            map.easeTo({
              center: clickedFeature.geometry.coordinates,
              zoom: map.getZoom() + 2,
            });
          } else {
            if (clickedFeature.properties.isState) {
              setNearByStateSelected(clickedFeature.properties.name);
              map.setZoom(7);
              map.setCenter(clickedFeature.geometry.coordinates);
            } else if (clickedFeature.properties.isCity) {
              setNearByCitySelected(clickedFeature.properties.name);
              map.setZoom(10);
              map.setCenter(clickedFeature.geometry.coordinates);
            }
          }
        }
      });
    }
 
    return () => {
      try {
        if (markerClusterRef.current?.remove) {
          markerClusterRef.current.remove();
          markerClusterRef.current = null;
        }
 
        const map = mapInstanceRef.current;
        if (map?.remove && map._container && map._canvas) {
          requestAnimationFrame(() => {
            try {
              map.remove();
              mapInstanceRef.current = null;
            } catch (e) {
              console.warn("Map remove failed:", e);
            }
          });
        } else {
          mapInstanceRef.current = null;
        }
      } catch (e) {
        console.warn("Map cleanup error:", e);
      }
    };
  }, [isLoaded, type, setNearByStateSelected, setNearByCitySelected]);

  // Resize map when container dimensions change (handles layout shifts)
  useEffect(() => {
    const container = document.getElementById("map");
    if (!container) return;
    const resizeObserver = new ResizeObserver(() => {
      const map = mapInstanceRef.current;
      if (map && typeof map.resize === "function") map.resize();
    });
    resizeObserver.observe(container);
    return () => resizeObserver.disconnect();
  }, [isLoaded]);

  // Update markers when mapData changes (e.g. after API fetch completes)
  useEffect(() => {
    if (!mapInstanceRef.current || !isLoaded) return;
    addCircleMarkers(mapInstanceRef.current);
  }, [mapData, isLoaded]);

  useEffect(() => {
    if (!mapInstanceRef.current || !isLoaded) return;

    const map = mapInstanceRef.current;
    if (!map.getLayer("circle-layer")) return;
 
    map.setPaintProperty("circle-layer", "circle-color", [
      "case",
      ["==", ["get", "isState"], true],
      locationStatusChoice === "Counterfeit" ? "#ff0000" : "#ffa600",
      locationStatusChoice === "Counterfeit" ? "#ff0000" : "#ffa600",
    ]);
    if (map.isStyleLoaded()) {
      addCircleMarkers(map);
    } else {
      const onStyleLoad = () => {
        addCircleMarkers(map);
        map.off("styledata", onStyleLoad); // clean up
      };
      map.on("styledata", onStyleLoad); // wait for style to load
    }
  }, [zoom, isLoaded, locationStatusChoice]);
 
 
  const addCircleMarkers = (map) => {
    if (!map) return;

    if (map.getSource("locationData")) {
      if (map.getLayer("circle-layer")) {
        map.removeLayer("circle-layer");
      }
      map.removeSource("locationData");
    }

    if (!Array.isArray(mapData) || mapData.length === 0) return;

    const currentZoom = map.getZoom();
    const features = [];

    mapData.forEach((state) => {
      const lat = state.latitude ?? state.lat;
      const lng = state.longitude ?? state.lng;
      if (lat == null || lng == null) return;
      if (currentZoom < 7) {
        features.push({
            type: "Feature",
            properties: {
              isState: true,
              name: state.state || state.location || state.city,
              count: state.product_count ?? state.count ?? 0,
            },
          geometry: {
            type: "Point",
            coordinates: [lng, lat],
          },
        });
      } else {
        state.cities?.forEach((city) => {
          const cityLat = city.latitude ?? city.lat;
          const cityLng = city.longitude ?? city.lng;
          if (cityLat == null || cityLng == null) return;
          features.push({
            type: "Feature",
            properties: {
              isCity: true,
              name: city.city || city.location,
              count: city.product_count ?? city.count ?? 0,
            },
            geometry: {
              type: "Point",
              coordinates: [cityLng, cityLat],
            },
          });
        });
      }
    });
 
    // Define min and max radius for visual scaling
    const MIN_RADIUS = 8; // Minimum radius in pixels
    const MAX_RADIUS = 60; // Maximum radius in pixels
 
    // Dynamically compute min and max count from features
    let maxCount = 0;
    let minCount = Infinity;
 
    features.forEach((f) => {
      const c = f.properties.count;
      if (c > maxCount) maxCount = c;
      if (c < minCount) minCount = c;
    });
 
    // Fallback to prevent division by zero
    if (minCount === maxCount) {
      minCount = 0;
    }
 
    map.addSource("locationData", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features,
      },
    });
 
    map.addLayer({
      id: "circle-layer",
      type: "circle",
      source: "locationData",
      paint: {
        "circle-color": [
          "case",
          ["==", ["get", "isState"], true],
          locationStatusChoice === "Counterfeit" ? "#ff0000" : "#ffa600",
          locationStatusChoice === "Counterfeit" ? "#ff0000" : "#ffa600",
        ],
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["get", "count"],
          minCount, MIN_RADIUS,
          maxCount, MAX_RADIUS
        ],
        "circle-opacity": 0.6,
        "circle-stroke-width": 0,
        "circle-stroke-color": "#000",
      },
    });
 
    map.on("click", "circle-layer", (e) => {
      const feature = e.features[0];
      const coordinates = feature.geometry.coordinates.slice();
      const name = feature.properties.name;
 
      if (feature.properties.isState) {
        setNearByStateSelected(name);
        map.setZoom(7);
        map.setCenter(coordinates);
      } else if (feature.properties.isCity) {
        setNearByCitySelected(name);
        map.setZoom(10);
        map.setCenter(coordinates);
      }
    });
 
    map.on("mouseenter", "circle-layer", () => {
      map.getCanvas().style.cursor = "pointer";
    });
 
    map.on("mouseleave", "circle-layer", () => {
      map.getCanvas().style.cursor = "";
    });
  };
 
 
  return <div id="map" style={mapContainerStyle}></div>;
};
 
export default LocationMapComponent;